<template>
  <v-dialog v-model="showLotti" max-width="1000px">
    <v-card :loading="loading">
      <v-card-title>
        <span class="text-h5">Dettagli lotto</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row v-if="prodotto && riga.custom">
            <v-col cols="12" sm="6" md="4" >
              <v-text-field v-model="riga.custom.fornitore" label="Lotto fornitore"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" >
              <v-menu
                v-model="menuProduzione"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="produzioneFormatted"
                    label="Data produzione"
                    prepend-icon="mdi-calendar"
                    readonly
                    dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="riga.custom.produzione"
                  no-title
                  @input="menuProduzione = false"
                ></v-date-picker>
              </v-menu>
              <!-- <v-text-field v-model="riga.lotto.produzione" label="Data produzione"></v-text-field> -->
            </v-col>                
            <v-col cols="12" sm="6" md="4" >
              <v-menu
                v-model="menuScadenza"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="scadenzaFormatted"
                    label="Data scadenza"
                    prepend-icon="mdi-calendar"
                    readonly
                    dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="riga.custom.scadenza"
                  no-title
                  @input="menuScadenza = false"
                ></v-date-picker>
              </v-menu>              
              <!-- <v-text-field v-model="riga.lotto.scadenza" label="Data scadenza"></v-text-field> -->
            </v-col>
            <v-col cols="12" sm="6" md="4" > 
              <v-text-field v-model="riga.custom.riferimento" label="Riferimento"></v-text-field>
            </v-col>         
            <v-col cols="12" sm="6" md="8" > 
              <v-text-field v-model="riga.custom.info" label="Info lotto"></v-text-field>
            </v-col>              
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-title>
        <span class="text-h6">Tracciabilità carni</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row v-if="prodotto && riga.custom && riga.custom.carne">
            <v-col cols="12" sm="6" md="4" >
              <v-text-field v-model="riga.custom.carne.auricolare" label="Numero matricola"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" >
              <v-text-field v-model="riga.custom.carne.origine" label="Origine"></v-text-field>
            </v-col>                
            <v-col cols="12" sm="6" md="4" > 
              <v-text-field v-model="riga.custom.carne.allevamento" label="Allevamento"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="8" > 
              <v-text-field v-model="riga.custom.carne.macellazione" label="Macellazione"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" > 
            </v-col>                       
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="close"
        >
          Annulla
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="save"
        >
          Salva
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    show: Boolean,
    prodotto: { // TODO: Separare la gestione dell'oggetto interno dalla props
      type: Object,
      default: () => { custom: { carne : {} } }
    }
  },
  data () {
    return {
      loading: false,
      showLotti: false,
      riga: null,
      menuProduzione: false,
      menuScadenza: false
    }
  },
  watch: {
    show(value) {
      if (value) {
        this.showLotti = true
      }
    },
    prodotto(value) {
      this.riga = value
    }
  },
  computed: {
    produzioneFormatted () {
      return this.formatDate(this.riga.custom.produzione)
    },
    scadenzaFormatted () {
      return this.formatDate(this.riga.custom.scadenza)
    }
  },
  methods: {
    changeProduzione(result) {
      console.log(result.value)
    },
    close() {
      this.showLotti = false
    },
    save() {
      this.showLotti = false
      this.$emit('save', this.riga.custom)
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>